<mat-card class="daxa-card overview-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-content>
        <div class="overview-card__header">
            <div>
                <span>{{ 'pie_dashboard.overview.kicker' | translate }}</span>
                <h2>{{ 'Fleet_performance_at_a_glance' | translate }}</h2>
            </div>
            <div class="overview-card__live">
                <span></span>
                {{ 'pie_dashboard.overview.updated_now' | translate }}
            </div>
        </div>

        <div class="row overview-card__grid">
            <div class="col-md-6 col-xxxl-3">
                <app-daily-production></app-daily-production>
            </div>
            <div class="col-md-6 col-xxxl-3">
                <app-total-production></app-total-production>
            </div>
            <div class="col-md-6 col-xxxl-3">
                <app-co2-savings></app-co2-savings>
            </div>
            <div class="col-md-6 col-xxxl-3">
                <app-total-systems></app-total-systems>
            </div>
        </div>
    </mat-card-content>
</mat-card>
